import { invoiceFees } from "../Constants/invoiceFee";
import { paymentTerms } from "../Constants/paymentTerms";
import helpers from "./helpers";
import {VossCustomerStatusDropdown} from "../Constants/VOSS/vossCustomerStatus";

export const customerFields = {
    name: { name: 'name', label: 'maininfocontainer.name', type: 'text' },
    organizationNumber: { name: 'organizationNumber', label: 'maininfocontainer.organizationnumber', type: 'tel' },
    testCustomer: { name: 'testCustomer', label: 'maininfocontainer.testcustomer', type: 'checkbox' },
    customerNumber: { name: 'customerNumber', label: 'maininfocontainer.customernumber', type: 'text' },
    invoiceCustomerNumber: { name: 'invoiceCustomerNumber', label: 'internalinfocontainer.invoicecustomernumber', type: 'customerSearch' },
    email: { name: 'email', label: 'maininfocontainer.invoiceemail', type: 'email' },
    contactPersonFirstName: { name: 'contactPersonFirstName', label: 'maininfocontainer.firstname', type: 'text' },
    contactPersonLastName: { name: 'contactPersonLastName', label: 'maininfocontainer.lastname', type: 'text' },
    contactPersonFullName: { name: 'contactPersonFullName', label: 'maininfocontainer.name', type: 'text' },
    contactPersonEmail: { name: 'contactPersonEmail', label: 'maininfocontainer.email', type: 'email' },
    contactPersonPhoneNumber: { name: 'contactPersonPhoneNumber', label: 'maininfocontainer.phonenumber', type: 'tel' },
    address: { name: 'address', label: 'maininfocontainer.streetaddress', type: 'text' },
    postalCode: { name: 'postalCode', label: 'maininfocontainer.postalcode', type: 'number' },
    city: { name: 'city', label: 'maininfocontainer.postalcity', type: 'text' },
    careOf: { name: 'careOf', label: 'maininfocontainer.coaddress', type: 'text' },
    fetchAddress: { name: 'fetchAddress', label: 'maininfocontainer.fetchaddress', type: 'button' },
    creditLimit: { name: 'creditLimit', label: 'internalinfocontainer.creditlimit', type: 'number' },
    invoiceFee: { name: 'invoiceFee', label: 'internalinfocontainer.invoicefee', type: 'dropdown' },
    spcsEdi: { name: 'spcsEdi', label: 'internalinfocontainer.spcsedi', type: 'dropdown' },
    paymentTerms: { name: 'paymentTerms', label: 'internalinfocontainer.paymentterms', type: 'dropdown' },
    responsibleSalesPerson: { name: 'responsibleSalesPerson', label: 'internalinfocontainer.responsibleperson', type: 'userSearch' },
    type: { name: 'type', label: 'internalinfocontainer.customertype', type: 'dropdown' },
    status: { name: 'status', label: 'internalinfocontainer.customerstatus', type: 'dropdown' },
    customerGroup: { name: 'customerGroup', label: 'internalinfocontainer.customergroup', type: 'dropdown' },
    targetGroups: { name: 'targetGroups', label: 'internalinfocontainer.targetgroup', type: 'targetGroupInputTable' },
    expiryDate: { name: 'expiryDate', label: 'maininfocontainer.expirydate', type: 'dateTime' },
    isVerified: { name: 'isVerified', label: 'maininfocontainer.verifiedcustomer', type: 'checkbox' },
    isAddressLocked: { name: 'isAddressLocked', label: 'maininfocontainer.isAddressLocked', type: 'checkbox' },
    isInvoiceEmailLocked: { name: 'isInvoiceEmailLocked', label: 'maininfocontainer.isInvoiceEmailLocked', type: 'checkbox' },
    statusVoss: { name: 'statusVoss', label: 'internalinfocontainer.statusvoss', type: 'dropdown' }
};

const contactPersonFieldset = (additionalProps = {}) => ({
    label: 'maininfocontainer.contactperson',
    fields: [
        customerFields.contactPersonFirstName,
        customerFields.contactPersonLastName,
        customerFields.contactPersonEmail,
        customerFields.contactPersonPhoneNumber
    ],
    ...additionalProps
});

const vbContactPerson = (additionalProps = {}) => ({
    label: 'maininfocontainer.contactperson',
    fields: [
        customerFields.contactPersonFullName,
        customerFields.contactPersonEmail,
        customerFields.contactPersonPhoneNumber
    ],
    ...additionalProps
});

const addressFieldset = (additionalProps = {}, additionalFields = []) => ({
    label: 'maininfocontainer.address',
    fields: [
        { ...customerFields.address, isDisabled: (params) => params.isAddressLocked && !params.userHasInternalInfoRole },
        { ...customerFields.postalCode, isDisabled: (params) => params.isAddressLocked && !params.userHasInternalInfoRole },
        { ...customerFields.city, isDisabled: (params) => params.isAddressLocked && !params.userHasInternalInfoRole },
        { ...customerFields.careOf, isDisabled: (params) => params.isAddressLocked && !params.userHasInternalInfoRole },
        ...additionalFields
    ],
    ...additionalProps
});

const internalInfoFieldset = (dropdownLists = {}, additionalFields = []) => ({
    label: 'internalinfocontainer.header',
    fields: [
        { ...customerFields.creditLimit, isDisabled: (params) => !params.userHasInternalInfoRole },
        { ...customerFields.invoiceFee, options: invoiceFees, isDisabled: (params) => !params.userHasInternalInfoRole },
        { ...customerFields.spcsEdi, options: dropdownLists?.SpcsEdi, isDisabled: (params) => !params.userHasInternalInfoRole },
        { ...customerFields.paymentTerms, options: paymentTerms, isDisabled: (params) => !params.userHasInternalInfoRole },
        customerFields.responsibleSalesPerson,
        { ...customerFields.type, options: dropdownLists?.CustomerType },
        { ...customerFields.status, options: dropdownLists?.CustomerStatus },
        { ...customerFields.customerGroup, options: dropdownLists?.CustomerGroup, nameAggregate: (group) => group ? helpers.formatGroupName(group) : 'internalinfocontainer.selectcustomergroup' },
        ...additionalFields
    ]
});


export const VossCreateForm = () => {
    return [
        {
            label: 'maininfocontainer.companyinfo',
            fields: [
                {...customerFields.name, isDisabled: (params) => !params.businessCheck},
                {...customerFields.organizationNumber, isDisabled: (params) => params.businessCheckLoading || params.testCustomer, isLoading: (params) => params.businessCheckLoading},
                {...customerFields.testCustomer, isDisabled: (params) => params.businessCheckLoading},
                {...customerFields.expiryDate, isHidden: (params) => !params.showExpiryDate, isRequired: (params) => !params.showExpiryDate},
            ]
        },
        contactPersonFieldset({isDisabled: (params) => !params.businessCheck}),
        addressFieldset({isDisabled: (params) => !params.businessCheck}),
    ];
}
export const VonCreateForm = () => {
    return [
        contactPersonFieldset(),
        addressFieldset()
    ];
};
export const VbEditForm = (dropdownLists) => {
    return [
        [{
            label: 'maininfocontainer.companyinfo',
            fields: [
                customerFields.name,
                { ...customerFields.customerNumber, isDisabled: (params) => !params.userHasCustomerNumberAdminRole },
                { ...customerFields.organizationNumber, isDisabled: (params) => !params.userHasOrganizationNumberAdminRole },
                { ...customerFields.invoiceCustomerNumber, isDisabled: (params) => !params.userHasInvoiceReceiverRole },
                { ...customerFields.email, isDisabled: (params) => params.isInvoiceEmailLocked && !params.userHasInternalInfoRole },
                {...customerFields.isInvoiceEmailLocked, isDisabled: (params) => params.isInvoiceEmailLocked && !params.userHasInternalInfoRole}
            ]
        },
            vbContactPerson()],
        [
            addressFieldset({}, [customerFields.fetchAddress, {...customerFields.isAddressLocked, isDisabled: (params) => params.isAddressLocked && !params.userHasInternalInfoRole}]),
            internalInfoFieldset(dropdownLists, [])
        ]
    ];
};
export const VbAndVossEditForm = (dropdownLists) => {

    const newField = [
        {...customerFields.statusVoss, options: VossCustomerStatusDropdown},
        {...customerFields.isVerified, isDisabled: (params) => !params.userHasInternalInfoRole}
    ]

    const targetGroupFieldset = {
        label: 'internalinfocontainer.targetgroup',
        fields: [
            {...customerFields.targetGroups, options: dropdownLists?.TargetGroup},
            {...customerFields.expiryDate, isHidden: (params) => !params.showExpiryDate, isRequired: (params) => !params.showExpiryDate}
        ]
    };
    return [
        [{
            label: 'maininfocontainer.companyinfo',
            fields: [
                customerFields.name,
                {...customerFields.customerNumber, isDisabled: (params) => !params.userHasCustomerNumberAdminRole},
                {...customerFields.organizationNumber, isDisabled: (params) => !params.userHasOrganizationNumberAdminRole},
                {...customerFields.invoiceCustomerNumber, isDisabled: (params) => !params.userHasInvoiceReceiverRole},
                { ...customerFields.email, isDisabled: (params) => params.isInvoiceEmailLocked && !params.userHasInternalInfoRole },
                {...customerFields.isInvoiceEmailLocked, isDisabled: (params) => params.isInvoiceEmailLocked && !params.userHasInternalInfoRole}
            ]
        },
            contactPersonFieldset(),
            addressFieldset({}, [customerFields.fetchAddress, {...customerFields.isAddressLocked, isDisabled: (params) => params.isAddressLocked && !params.userHasInternalInfoRole}])],
        [
            internalInfoFieldset(dropdownLists, [...newField]),
            targetGroupFieldset
        ]
    ];
};

export const VossEditForm = (dropdownLists) => {

    const targetGroupFieldset = {
        label: 'internalinfocontainer.targetgroup',
        fields: [
            {...customerFields.targetGroups, options: dropdownLists?.TargetGroup},
            {
                ...customerFields.expiryDate,
                isHidden: (params) => !params.showExpiryDate,
                isRequired: (params) => !params.showExpiryDate
            }
        ]
    };

    return [
        [{
            label: 'maininfocontainer.companyinfo',
            fields: [
                customerFields.name,
                {...customerFields.customerNumber, isDisabled: (params) => !params.userHasCustomerNumberAdminRole},
                {...customerFields.organizationNumber, isDisabled: (params) => !params.userHasOrganizationNumberAdminRole},
                { ...customerFields.email, isDisabled: (params) => params.isInvoiceEmailLocked && !params.userHasInternalInfoRole },
                {...customerFields.isInvoiceEmailLocked, isDisabled: (params) => params.isInvoiceEmailLocked && !params.userHasInternalInfoRole}
            ]
        },
            contactPersonFieldset()
        ],
        [
            addressFieldset({}, [customerFields.fetchAddress, {...customerFields.isAddressLocked, isDisabled: (params) => params.isAddressLocked && !params.userHasInternalInfoRole}]),
            {
                label: 'internalinfocontainer.header',
                fields: [
                    {...customerFields.statusVoss, options: VossCustomerStatusDropdown},
                    {...customerFields.isVerified, isDisabled: (params) => !params.userHasInternalInfoRole }
                ]
            },
            targetGroupFieldset
        ]
    ]
}
